// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_f-n","cls2":"FeedbackModal-cls2_8yo FeedbackModal-cls1_f-n"};